import React, { Component } from 'react'
import Hero from "../commons/Hero";
import { Link } from "react-router-dom";
import Navbar from "../commons/Navbar";



export class Projects extends Component {
 

  render() {
    return (
      <div className="projects">
        <Navbar />

        <Hero heading="Portfolio" image="assets/img/herobg-resume.jpg" />

        <div className="container">
          <div className="content">
            <h2 className="heading-2">My Professional Work</h2>

            <p>
              These are some of my projects that have done with clients. I
              actively maintain both sites, and The Practice of Arthur E. Cash
              is in the process of being completely redesigned to give it a
              modern look and feel.
            </p>

            <div className="projectList">
              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/weqed.jpg"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">Mount Calvary Baptist Church</h3>
                  <p>
                    This is the website for Mount Calvary Baptist Church in
                    Springfield,MA.
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/calvary">MORE </Link>
                </div>
              </div>

              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/header.jpg"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">The Practice of Arthur E Cash</h3>
                  <p>
                    This is a website for Arthur E. Cash, who is a Mental Health
                    therapist located in East Longmeadow, MA.
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/arthurorig">MORE </Link>
                </div>
              </div>
            </div>

            <h2 className="heading-2">My Startup/Side Projects</h2>

            <p>
              These are some of my side projects that I have put together, while
              learning multiple technologies. These projects give an insight
              into some of the skills I have learned over time.
            </p>

            <div className="projectList">
              
              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/5591df02-df78-4383-b69c-92ba64cfda80.jpg"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">MassNow News Site</h3>
                  <p>
                    This is a newly completed MERN stack project, a fictional
                    multi user news site similar to Masslive.com. ....
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/massnow">MORE </Link>
                </div>
              </div>

              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/35035f91-0e14-4e99-a0c8-81ca6f6eb4b1.jfif"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">The Social Cuisiner</h3>
                  <p>
                    A very simple fictional social network project, that focuses
                    on the love of food and recipe sharing. ....
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/social">MORE </Link>
                </div>
              </div>

              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/landing-heading.jpg"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">Social Sole</h3>
                  <p>
                    This is a very simple fictional social media site, built
                    with the MERN stack based around the love of sneakers ....
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/sole">MORE </Link>
                </div>
              </div>

              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/FireShot Capture 191 - The PostMaster - http___localhost_3000_.jpg"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">The Postmaster</h3>
                  <p>
                    A very simple app, that a user can send out surveys to
                    customers to get feedback. This was built with a React.js
                    frontend, and a Node.js back-end. ....
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/postmaster">MORE </Link>
                </div>
              </div>

              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/blueleaf-1.jpg"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">Blueleaf University</h3>
                  <p>
                    This is a very simple, fictional University site that's
                    built with Wordpress, including a custom theme, that's built
                    from scratch....
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/blueleaf">MORE </Link>
                </div>
              </div>

              <div className="project">
                <img
                  class="card-img-top"
                  src="assets/img/screenshots/lrg/66e2201b-d67e-45a3-ac14-4f977f019d50.jpg"
                  alt="card"
                />

                <div class="card-body">
                  <h3 className="heading-3">Envirogreen Reality</h3>
                  <p>
                    This A very simple, fictional Real Estate site, complete
                    with searching capabilities, and a small admin cms, which
                    has full CRUD capabilities...
                  </p>
                </div>

                <div className="btn btn-babyblue">
                  <Link to="/envirogreen">MORE </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Projects
